/** Hands the browser a text file to save (the CSV for the tax advisor). */
export function downloadText(
  filename: string,
  text: string,
  type = 'text/csv;charset=utf-8'
): void {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
